<template>
  <section
    class="fb fb-cross-center fb-main-center timer-popup"
    @touchmove.prevent
    @click="maskClick"
    v-if="show"
  >
    <div class="fb fb-col timer-popup-content">
      <div class="c-171A1D font-34 pt-12 p-0-12 h-36 lh-24 timer-title mb-8">{{
        title
      }}</div>
      <div class="item-flex-1 fb fb-main-center relative timer-picker-wrapper">
        <div
          v-for="(options, index) in computedColumns"
          :key="index"
          class="timer-picker-list"
          :class="`timer-picker-list${index}`"
        >
          <ul :ref="`picker${index}`" class="item-flex-1 timer-picker-column">
            <li
              class="timer-picker-item font-32 fb fb-main-center fb-cross-center"
              :class="[idx === selectedArray[index] && 'font-48']"
              :style="{ height: `${heightObj[phoneType]}px` }"
              v-for="(itm, idx) in options"
              :key="`option${idx}`"
              @click.stop="clickHandler(index, idx)"
              >{{ itm }}
            </li>
          </ul>
        </div>
        <div class="mask-top"></div>
        <div
          class="high-light fb fb-row fb-cross-center fb-main-center"
          :class="[IS_ANDROID ? 'mt-4' : 'mt--2']"
        >
          <span class="tag-box mr-16"></span
          ><span
            class="inline-block font-32 w-10 text-center text-bold lh-48 h-48"
            >:</span
          ><span class="tag-box ml-16"></span>
        </div>
        <div class="mask-bottom"></div>
      </div>
      <footer class="font-34 c-006AFE timer-picker-footer fb fb-main-between">
        <div class="item-flex-1 text-center cancel" @click="cancelHandler">{{
          cancelText
        }}</div>
        <div
          class="item-flex-1 text-center text-bold confirm"
          @click="confirmHandler"
          >{{ confirmText }}</div
        >
      </footer>
    </div>
  </section>
</template>

<script>
import { IS_ANDROID } from '@/utils/comUtils'
import Picker from './picker-core.js'
export default {
  name: 'commonTimer',
  components: {},
  props: {
    isVisible: {
      type: Boolean,
      default: true
    },
    title: {
      type: String,
      default: '预计留堂至'
    },
    cancelText: {
      type: String,
      default: '取消'
    },
    confirmText: {
      type: String,
      default: '确认'
    },
    columns: {
      type: Array,
      default() {
        let _hour = []
        let _minute = []
        for (let i = 0; i < 24; i++) {
          _hour.push(`0${i}`.replace(/.*(.{2})/, '$1'))
        }
        for (let i = 0; i < 60; i++) {
          _minute.push(`0${i}`.replace(/.*(.{2})/, '$1'))
        }
        return [
          {
            options: _hour,
            defaultActive: 0
          },
          {
            options: _minute,
            defaultActive: 0
          }
        ]
      }
    },
    defaultActive: {
      type: [Array, Number],
      default: 0
    }
  },
  data() {
    return {
      IS_ANDROID: IS_ANDROID,
      winW:
        window.innerWidth ||
        document.documentElement.clientWidth ||
        document.body.clientWidth,
      winH:
        window.innerHeight ||
        document.documentElement.clientHeight ||
        document.body.clientHeight,
      show: this.isVisible,
      index: 0,
      selectedArray: [0, 0],
      selectedValues: [0, 0],
      inst: [null, null],
      phoneType: IS_ANDROID ? 'android' : 'ios',
      heightObj: {
        android: 48,
        ios: 48,
        ios7p: 55
      }
    }
  },
  computed: {
    computedColumns() {
      return this.columns.reduce((_list, item) => {
        return _list.concat([item.options])
      }, [])
    },
    computedDefaultIndex() {
      return this.columns.reduce((_list, item) => {
        return _list.concat(item.defaultActive)
      }, [])
    }
  },
  watch: {
    isVisible(v) {
      this.show = v
    }
  },
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {
    if (!IS_ANDROID && this.winW === 414) {
      this.phoneType = 'ios7p'
    }
    this.columns.forEach((item, i) => {
      this.$set(this.selectedArray, i, this.defaultActive[i])
      this.$set(this.selectedValues, i, item.options[this.defaultActive[i]])
    })
    let _that = this
    this.$nextTick(async () => {
      const _len = (this.columns || []).length
      for (let i = 0; i < _len; i++) {
        _that.inst[i] = await new Picker(this.$refs[`picker${i}`][0], {
          current: this.selectedArray[i],
          itemHeight: this.heightObj[this.phoneType] || 48,
          change(index) {
            _that.onChange(index, i)
          }
        })
      }
    })
  },
  beforeUpdate() {},
  updated() {},
  activated() {},
  deactivated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    maskClick(e) {
      // this.$emit('mask-click', e)
      // this.show = false
    },
    cancelHandler() {
      this.show = false
      this.$emit('cancel')
    },
    confirmHandler() {
      this.show = false
      this.$emit('confirm', this.selectedArray, this.selectedValues)
    },
    clickHandler(index, idx) {
      this.inst && this.inst[index] && this.inst[index].locate(idx)
    },
    onChange(_index, i) {
      this.$set(this.selectedArray, i, _index)
      this.$set(this.selectedValues, i, this.columns[i].options[_index])
    }
  }
}
</script>

<style lang="scss" scoped>
.timer-popup {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  z-index: 99;
  background-color: rgba(23, 26, 29, 0.28);
  .timer-popup-content {
    pointer-events: auto;
    width: 280px;
    height: 240px;
    background: #fff;
    border-radius: 12px;
  }
  .timer-title {
    font-weight: 500;
    text-align: center;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .timer-picker-footer {
    height: 48px;
    line-height: 48px;
    border-top: 1px solid rgba(17, 31, 44, 0.12);
    position: relative;
    .cancel {
      border-right: 1px solid rgba(17, 31, 44, 0.12);
    }
  }
  .timer-picker-wrapper {
    height: 124px;
    overflow: hidden;
  }

  .mask-top {
    position: absolute;
    z-index: 9;
    top: 0px;
    left: 0;
    height: 45px;
    width: 100%;
    background: linear-gradient(0deg, rgba(255, 255, 255, 0.3), #ffffff);
    pointer-events: none;
  }
  .mask-bottom {
    position: absolute;
    z-index: 9;
    bottom: 0px;
    left: 0;
    height: 45px;
    width: 100%;
    background: linear-gradient(0deg, #ffffff, rgba(255, 255, 255, 0.3));
    pointer-events: none;
  }
  .high-light {
    position: absolute;
    top: 50%;
    left: 0;
    z-index: 4;
    width: 100%;
    -webkit-transform: translateY(-50%);
    transform: translateY(-50%);
    pointer-events: none;
    height: 48px;
    .tag-box {
      display: inline-block;
      width: 85px;
      height: 48px;
      background: rgba(0, 0, 0, 0.08);
      border-radius: 8px;
    }
  }
  .mt--2 {
    margin-top: -2px;
  }
  .timer-picker-content {
    position: relative;
    width: 100%;
    z-index: 3;
  }

  .timer-picker-list {
    width: 85px;
    overflow: hidden;
    .timer-picker-column {
      width: 100%;
      -webkit-transition-timing-function: cubic-bezier(0.23, 1, 0.68, 1);
      transition-timing-function: cubic-bezier(0.23, 1, 0.68, 1);
      .timer-picker-item {
        // background: linear-gradient(0deg, red, green);
        padding: 0 4px;
        box-sizing: border-box;
      }
    }
  }
  .timer-picker-list0 {
    margin-right: 38px;
  }
}
</style>
